// socket.ts
import { io } from "socket.io-client";
const socket = io("https://gnatowski.ddns.net", {
    path: "/socket.io",
    transports: ["websocket"],
    withCredentials: true
});
export default socket;
